<template>
  <div id="Recovery">
    <div class="bg-white">
      <div
        id="Nav"
        class="d-flex container flex-row align-items-center position-relative px-2 px-lg-0"
      >
        <div
          class="content-container d-flex flex-row flex-wrap justify-content-between align-items-center w-100"
        >
          <div>
            <img
              class="nav-logo ml-2 ml-sm-0"
              src="/img/axa-health.svg"
              alt="AXA Health Logo"
            />
          </div>
        </div>
      </div>
    </div>
    <div class=" error-banner" v-if="errorBanner">
      <div class="container">
        <b v-if="!popupError">Something went wrong.</b> {{ errorBannerString }}.
        <div class="py-4" v-if="!popupError">
          Please contact support@supportedemail.axahealth.co.uk to resolve this
          issue.
        </div>
      </div>
    </div>
    <div class="container d-flex flex-column mb-5 mt-5">
      <div class="col-12">
        <h1 class="brand-highlight-1 page-title text-center">
          Account Recovery
        </h1>
      </div>
    </div>
    <div class="container d-flex flex-column min-height">
      <div
        v-if="loading"
        class="row mt-5 d-flex justify-content-center align-items-center"
      >
        <Loader />
      </div>

      <div
        class="text-center error-message mx-auto brand-highlight-1 my-auto"
        v-else-if="errorPage"
      >
        <h1>
          Please contact support@supportedemail.axahealth.co.uk to resolve this
          issue.
        </h1>
      </div>

      <div
        class="text-center error-message mx-auto brand-highlight-1 my-auto"
        v-else-if="successPage"
      >
        <h1>
          Verification form submitted successfully. Please check your email for
          further instructions.
        </h1>
      </div>

      <div
        v-else
        class="row mt-5 d-flex justify-content-center align-items-center"
      >
        <div class="col-12">
          <div class="recovery-container">
            <div class="normal-container ">
              <div class="row d-flex align-items-center">
                <div class="col-12 col-md-6">
                  <label class="dmh-confirm-field semibold">Email</label>
                  <b-input
                    class="dmh-confirm-input"
                    aria-placeholder="Enter email"
                    v-model="email"
                  />
                  <label class="dmh-confirm-field semibold">First Name</label>
                  <b-input
                    class="dmh-confirm-input"
                    aria-placeholder="Enter first name"
                    v-model="f_name"
                  />
                  <label class="dmh-confirm-field semibold">Last Name </label>
                  <b-input
                    class="dmh-confirm-input"
                    aria-placeholder="Enter last name"
                    v-model="l_name"
                  />
                  <label class="dmh-confirm-field semibold">
                    Date of Birth
                  </label>
                  <b-form-input
                    :class="
                      dobError
                        ? 'dmh-confirm-input-no-margin'
                        : 'dmh-confirm-input'
                    "
                    type="date"
                    aria-placeholder="Enter date of birth"
                    v-model="dob"
                  />
                  <p class="pt-2 dob-error" v-if="dobError">
                    {{ dobError }}
                  </p>
                  <div class="button-wrapper mt-2 w-100">
                    <b-button
                      :disabled="buttonActive"
                      class="btn-height"
                      variant="cta"
                      size="lg"
                      block
                      @click="processRecovery"
                      squared
                      ><span v-if="!loading">Continue</span>
                      <b-spinner v-else></b-spinner>
                    </b-button>
                  </div>
                </div>
                <div class="image-container col-md-6 d-none d-md-flex">
                  <img
                    class="img-fluid ml-auto"
                    src="/img/homeHero.svg"
                    alt="Home Hero"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import config from "../config/constants";
import Loader from "../components/Loader";
import Footer from "../components/Footer";

export default {
  name: "Recovery",
  components: {
    Loader,
    Footer
  },
  data() {
    return {
      popupError: false,
      accessScreen: false,
      errorPage: false,
      successPage: false,
      dobError: false,
      errorBanner: false,
      errorBannerString: "",
      loading: false,
      warning: "",
      email: "",
      f_name: "",
      l_name: "",
      dob: ""
    };
  },
  methods: {
    async processRecovery() {
      this.errorBanner = false;
      this.loading = true;

      if (!this.validateAdultDob(this.dob)) {
        this.dobError =
          "You must be at least 16 years old to use this service.";
        this.loading = false;
        return;
      }

      let payload = {
        email: this.email,
        firstname: this.f_name,
        lastname: this.l_name,
        dob: this.dob
      };
      let res = await axios.post(
        config.api_env +
          "/application/api/u/sapphire/alternative/axa-password-reset",
        payload,
        config.options
      );

      if (res.data) {
        if (res.data.success) this.successPage = true;
        else if (res.data.err) {
          this.errorBanner = true;
          this.errorBannerString = res.data.err;
          window.scrollTo(0, 0);
        } else {
          this.errorPage = true;
        }
      }
      this.loading = false;
    }
  },
  computed: {
    buttonActive() {
      let active = true;
      if (
        this.f_name.length === 0 ||
        this.l_name.length === 0 ||
        this.dob.length === 0 ||
        this.email.length === 0
      ) {
        active = false;
      }
      return !active;
    }
  }
};
</script>
<style lang="less">
#Recovery {
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  min-height: 100vh;

  button {
    padding: 15px !important;
    font-size: 16px;
  }

  .btn-height {
    min-height: 50px;
  }

  .page-title {
    font-size: 4rem;
  }

  .min-height {
    min-height: 70vh;
  }

  .error-banner {
    width: 100%;
    padding: 20px;
    color: white;
    background-color: #c91432;
    font-size: 1.6rem;
    text-align: center;
  }

  .error-message {
    max-width: 600px;
    align-self: center;
    justify-self: center;
  }

  .recovery-container {
    .normal-container {
      background: white;
      padding: 55px 45px;
    }
  }

  label {
    font-family: "DMSans", serif;
    font-size: 1.6rem;
    margin-bottom: 10px;
  }

  .dmh-confirm-input-no-margin {
    padding: 15px;
    border: 1px solid #757575;
    border-radius: 8px;
    font-size: 1.8rem;
    min-height: 50px;
  }

  .dmh-confirm-input {
    padding: 15px;
    border: 1px solid #757575;
    border-radius: 8px;
    margin-bottom: 30px;
    font-size: 1.8rem;
    min-height: 50px;
  }

  .dob-error {
    font-size: 1.6rem;
    color: #c91432;
  }

  .container {
    flex: 1 1 100%;
  }
}
</style>
